"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _UserAvatar = _interopRequireDefault(require("@insided/deprecated-preact-components/User/UserAvatar"));

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _userService = require("@insided/shared/services/userService");

var _Tooltip = _interopRequireDefault(require("@insided/shared/uikit/Tooltip"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var anonymousUser = {
  id: '',
  name: 'Anonymous',
  avatar: ''
};

var VotedUsers = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(VotedUsers, _Component);

  var _super = _createSuper(VotedUsers);

  function VotedUsers() {
    var _this;

    (0, _classCallCheck2.default)(this, VotedUsers);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      votedUsers: [],
      anonymousVotesCount: 0,
      votedByUsers: []
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "fetchVotedUsers", /*#__PURE__*/(0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee() {
      var votedBy, _votedBy$length, response, total, userData;

      return _regenerator.default.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              votedBy = _this.props.votedBy;

              if (!((votedBy === null || votedBy === void 0 ? void 0 : votedBy.length) === 0)) {
                _context.next = 3;
                break;
              }

              return _context.abrupt("return");

            case 3:
              _context.prev = 3;
              _context.next = 6;
              return (0, _userService.fetchUserInfo)(votedBy);

            case 6:
              response = _context.sent;
              total = (_votedBy$length = votedBy === null || votedBy === void 0 ? void 0 : votedBy.length) !== null && _votedBy$length !== void 0 ? _votedBy$length : 0;
              userData = Object.values(response);

              _this.setState({
                votedUsers: userData,
                anonymousVotesCount: userData.length < total ? total - userData.length : 0,
                votedByUsers: votedBy
              });

              _context.next = 15;
              break;

            case 12:
              _context.prev = 12;
              _context.t0 = _context["catch"](3);
              // eslint-disable-next-line no-console
              console.log('Failed to fetch voted users:', _context.t0);

            case 15:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[3, 12]]);
    })));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleMouseEnterOrFocus", function () {
      var votedBy = _this.props.votedBy;
      var votedByUsers = _this.state.votedByUsers; // Fetch if not fetched yet OR if votedBy has changed

      if (votedByUsers.length === 0 || votedByUsers !== votedBy) {
        _this.fetchVotedUsers();
      }
    });
    return _this;
  }

  (0, _createClass2.default)(VotedUsers, [{
    key: "render",
    value: function render() {
      var _votedBy$length2;

      var _this$props = this.props,
          _this$props$topVotedU = _this$props.topVotedUsers,
          topVotedUsers = _this$props$topVotedU === void 0 ? [] : _this$props$topVotedU,
          votedBy = _this$props.votedBy,
          _this$props$previewCo = _this$props.previewCount,
          previewCount = _this$props$previewCo === void 0 ? 3 : _this$props$previewCo;
      var _this$state = this.state,
          votedUsers = _this$state.votedUsers,
          anonymousVotesCount = _this$state.anonymousVotesCount;
      var totalVotes = (_votedBy$length2 = votedBy === null || votedBy === void 0 ? void 0 : votedBy.length) !== null && _votedBy$length2 !== void 0 ? _votedBy$length2 : 0;
      var allUsers = votedUsers.length > 0 ? votedUsers : [];
      var displayUsers = topVotedUsers.slice(0, previewCount);
      var totalVotedByUsers = allUsers.length + anonymousVotesCount;

      if (totalVotes === 0) {
        return null;
      }

      return (0, _preact.h)("div", {
        className: "topic-voted-users m-v"
      }, (0, _preact.h)("button", {
        type: "button",
        className: "unstyled-button",
        onMouseEnter: this.handleMouseEnterOrFocus,
        onFocus: this.handleMouseEnterOrFocus,
        "aria-label": "".concat(totalVotes, " ").concat(totalVotes === 1 ? 'vote' : 'votes', " from users")
      }, (0, _preact.h)(_Tooltip.default, {
        withArrow: true,
        trigger: (0, _preact.h)("div", null, displayUsers.map(function (user) {
          return (0, _preact.h)(_UserAvatar.default, {
            key: user.id,
            disablePopup: true,
            user: user,
            extraClass: "avatar avatar--S",
            showRank: false
          });
        }), totalVotedByUsers - previewCount > 0 ? (0, _preact.h)("span", {
          className: "text--meta"
        }, "+", totalVotedByUsers - previewCount) : null),
        tooltipMessage: (0, _preact.h)("ul", {
          className: "post-like-list__complete-list"
        }, allUsers.map(function (votedUser) {
          return (0, _preact.h)("li", {
            key: votedUser.id,
            className: "post-like-list__item"
          }, (0, _preact.h)("a", {
            className: "link",
            href: (0, _absoluteUrlRuntime.resolveUrl)(votedUser.url)
          }, (0, _preact.h)(_UserAvatar.default, {
            user: votedUser,
            extraClass: "avatar avatar--S",
            disablePopup: true,
            showRank: false
          }), (0, _preact.h)("span", null, votedUser.name)));
        }), anonymousVotesCount > 0 && (0, _preact.h)("li", {
          className: "post-like-list__item"
        }, (0, _preact.h)("div", {
          className: "wrapper"
        }, (0, _preact.h)(_UserAvatar.default, {
          user: anonymousUser,
          extraClass: "avatar avatar--S",
          disablePopup: true,
          showRank: false
        }), (0, _preact.h)(_phrase.default, {
          p: "anonymous.users.count",
          count: {
            n: anonymousVotesCount
          },
          renderAsText: true
        }, function (anonymousVotes) {
          return (0, _preact.h)("span", null, anonymousVotes);
        }))))
      })));
    }
  }]);
  return VotedUsers;
}(_preact.Component);

var _default = VotedUsers;
exports.default = _default;